import type { CustomCellEditorProps } from '@cmg/data-grid';
import { SelectFieldCellEditor } from '@cmg/data-grid';

import type { RelationshipType } from '../../../../../../graphql';
import { relationshipTypeOptions } from './RelationshipTypeCellEditor.model';

export function RelationshipTypeCellEditor<TData>({
  initialValue,
  eventKey,
  parseValue,
  onValueChange,
}: Readonly<CustomCellEditorProps<TData, RelationshipType>>) {
  return (
    <SelectFieldCellEditor
      eventKey={eventKey}
      options={relationshipTypeOptions}
      initialValue={initialValue}
      onValueChange={onValueChange}
      parseValue={parseValue}
    />
  );
}
